import React from 'react';

const AboutSection: React.FC = () => {
  const scrollToDonate = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('donate')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section 
      id="about" 
      className="gm-about-section"
      style={{
        backgroundImage: 'url(/images/IMGL9283-min-scaled.jpg)'
      }}
    >
      <div className="gm-hero-inner">
        <div className="gm-hero-content">
            <h2>
              FOR IF NOT US, WHO? IF NOT NOW, WHEN?
            </h2>
          
          <h3>
          They will never know you …but they will feel the effects of the contribution you make. And there is surely no greater feeling than knowing you have diminished a suffering, safeguarded a childhood, or saved a life.
          </h3>
          
          <a 
            href="#donate" 
            onClick={scrollToDonate}
            className="gm-hero-link"
          >
            Give Now
          </a>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
